import type { ModuleManifest } from "./types";

export const projectsManifest: ModuleManifest = {
  name: "projects",
  label: "Project",
  labelPlural: "Projects",

  coreBOSModule: "Project",
  wsidPrefix: "50x",

  type: "standard",

  routes: {
    list: "/projects",
    show: "/projects/show/:id",
    create: "/projects/create",
    edit: "/projects/edit/:id",
  },

  navigation: {
    icon: "ProjectOutlined",
    order: 15,
    group: "Projects",
  },

  routing: {
    keywords: [
      "project",
      "projects",
      "initiative",
      "initiatives",
      "program",
      "programs",
    ],
    searchFields: ["projectname"],
    defaultSort: { field: "startdate", order: "desc" },
  },

  context: {
    supported: true,
    entityKey: "projects",
  },

  fields: [
    { name: "projectname", label: "Project Name", type: "string", required: true },
    {
      name: "linktoaccountscontacts",
      label: "Related To",
      type: "reference",
      referenceModule: "Accounts",
    },
    {
      name: "projectstatus",
      label: "Status",
      type: "picklist",
      options: [
        { value: "prospecting", label: "Prospecting" },
        { value: "initiated", label: "Initiated" },
        { value: "in progress", label: "In Progress" },
        { value: "waiting for feedback", label: "Waiting for Feedback" },
        { value: "on hold", label: "On Hold" },
        { value: "completed", label: "Completed" },
        { value: "delivered", label: "Delivered" },
        { value: "archived", label: "Archived" },
      ],
    },
    {
      name: "projecttype",
      label: "Type",
      type: "picklist",
      options: [
        { value: "administrative", label: "Administrative" },
        { value: "operative", label: "Operative" },
        { value: "other", label: "Other" },
      ],
    },
    { name: "startdate", label: "Start Date", type: "date" },
    { name: "targetenddate", label: "Target End Date", type: "date" },
    { name: "actualenddate", label: "Actual End Date", type: "date" },
    { name: "progress", label: "Progress", type: "number" },
    { name: "targetbudget", label: "Target Budget", type: "currency" },
    { name: "projecturl", label: "Project URL", type: "string" },
    { name: "description", label: "Description", type: "text" },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "ProjectTask",
      field: "projectid",
      relation: "one-to-many",
      label: "Tasks",
      icon: "CheckSquareOutlined",
      displayField: "projecttaskname",
      secondaryField: "projecttaskstatus",
    },
    {
      module: "ProjectMilestone",
      field: "projectid",
      relation: "one-to-many",
      label: "Milestones",
      icon: "FlagOutlined",
      displayField: "projectmilestonename",
    },
    {
      module: "Documents",
      relation: "many-to-many",
      label: "Documents",
      icon: "FolderOutlined",
      displayField: "notes_title",
    },
  ],

  requiredFields: ["projectname", "assigned_user_id"],

  massEdit: {
    enabled: true,
  },
};
